import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { buildAppConfig } from './app/app.config';
import {
  loadMessengerRuntimeConfig,
  MessengerRuntime,
} from './app/messenger/messenger-runtime';
import { resolveCatalogEnvironment } from './app/core/capability/capability.resolver';

async function bootstrap(): Promise<void> {
  const runtime = new MessengerRuntime();
  await loadMessengerRuntimeConfig(runtime);
  const env = resolveCatalogEnvironment(runtime.config);

  bootstrapApplication(App, buildAppConfig({ runtime, env })).catch((err) =>
    console.error(err),
  );
}

bootstrap();
